/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Webauthn_CancelledInputs */



/**
* | output |
* | --- |
* | "Passkey authentication was cancelled. Please try again." |
*
* @param {Auth_Webauthn_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_webauthn_cancelled = /** @type {((inputs?: Auth_Webauthn_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Webauthn_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey-Authentifizierung abgebrochen. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Passkey authentication was cancelled. Please try again.")
});